import { useEffect, useRef } from 'react';

export default function useSessionCloseBeacon({ isAuthenticated, apiBaseUrl }) {
  const hasSentCloseSignalRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated) {
      hasSentCloseSignalRef.current = false;
      return undefined;
    }

    const sendCloseSignal = () => {
      if (hasSentCloseSignalRef.current || typeof navigator.sendBeacon !== 'function') {
        return;
      }

      const refreshToken = localStorage.getItem('refreshToken');
      if (!refreshToken) {
        return;
      }

      const payload = JSON.stringify({
        refreshToken,
        pathname: window.location.pathname,
        closedAt: Date.now(),
      });

      hasSentCloseSignalRef.current = true;
      navigator.sendBeacon(
        `${apiBaseUrl}/auth/close`,
        new Blob([payload], { type: 'application/json' })
      );
    };

    const handleBeforeUnload = () => {
      sendCloseSignal();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [apiBaseUrl, isAuthenticated]);
}
